import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import dateFormat from "dateformat";
import WithdrawalsModal from "./WithdrawalsModal/WithdrawalsModal";
const WithdrawalsDetails = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [updateData, setupdateData] = useState([]);
  useEffect(() => {
    fetch(`https://api.velormall.com/api/admin/withdrawal/view/${id}`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
      });
  }, [updateData]);



  const handleAccept = (id) => {
    fetch(`https://api.velormall.com/api/admin/withdrawal/accept/${id}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setupdateData(data);
        toast.success(`${data.message}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((error) => console.log(error));
  };

  const [Modalshow, setModalshow] = useState(false);

  return (
    <>
      <WithdrawalsModal
        className="posce-trade-modal"
        show={Modalshow}
        setmodalshow={setModalshow}
        singledata={data}
        setupdateData={setupdateData}
        onHide={() => setModalshow(false)}
      />

      <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
        <h6 className="page-title">
          {data?.user_id?.username}  Withdraw Requested &nbsp;
          {data?.amount} USD
        </h6>
        <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins"></div>
      </div>

      <div className="row mb-none-30">
        <div className="col-lg-4 col-md-4 mb-30">
          <div className="card b-radius--10 overflow-hidden box--shadow1">
            <div className="card-body">
              <h5 className="mb-20 text-muted">
                Withdraw Via {data?.network}
              </h5>
              <ul className="list-group">
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Date
                  <span className="fw-bold">
                    {dateFormat(data.createdAt, "d-m-yyyy h:MM:ss TT")}
                  </span>
                </li>

                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Trx Number
                  <span className="fw-bold"> {data?.transaction}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Username
                  <span className="fw-bold">
                    <Link to={`/admin/user/details/${data?.user_id?._id}`}>
                      {data?.user_id?.username}
                    </Link>
                  </span>
                </li>

                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Amount
                  <span className="fw-bold">{data?.amount} USD</span>
                </li>


                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Payable
                  <span className="fw-bold">
                    {data.status === 1 ? <>{data?.amount} USD</> : <>0 USD</>}
                  </span>
                </li>

                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Status
                  {data.status === 0 ? (
                    <span className="badge badge--warning text-warning">
                      Pending
                    </span>
                  ) : (
                    ""
                  )}
                  {data.status === 1 ? (
                    <span class="badge badge--success text-success">
                      Approved
                    </span>
                  ) : (
                    ""
                  )}
                  {data.status === 2 ? (
                    <span class="badge badge--danger text-danger">
                      Rejected
                    </span>
                  ) : (
                    ""
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-8 col-md-8 mb-30">
          <div className="card b-radius--10 overflow-hidden box--shadow1">
            <div className="card-body">
              <h5 className="card-title border-bottom pb-2">
                User Withdraw Information
              </h5>

              <div className="row mt-4">
                <div className="col-md-12">
                  <h6>Wallet Name</h6>
                  <p>{data?.wallet_name}</p>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-12">
                  <h6>Currency</h6>
                  <p>{data?.currency}</p>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-12">
                  <h6>Network</h6>
                  <p>{data?.network}</p>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-12">
                  <h6>Withdrawal address</h6>
                  <p>{data?.withdrawal_address}</p>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-md-12">
                  {data.status === 0 ? (
                    <>
                      <button
                        onClick={() => handleAccept(data?._id)}
                        className="btn btn-outline-success ms-1 approveBtn"
                        data-id="108"
                        data-amount="990,000.00 USD"
                      >
                        <i className="fas la-check"></i> Approve
                      </button>
                      <button
                        onClick={() => setModalshow(true)}
                        className="btn btn-outline-danger ms-1 rejectBtn"
                        data-id="108"
                      >
                        <i className="fas fa-ban"></i> Reject
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WithdrawalsDetails;
